import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Business } from '../models/business.model';
import { EditAddAirportComponent } from '../edit-add-airport/edit-add-airport.component';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { AirportService } from '../../airport/airport.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { ConfirmRemoveAirportComponent } from '../confirm-remove-airport/confirm-remove-airport.component';
import { AirportSummary } from '../../airport/models/airport-summary.model';
import { hasTag } from '../../util/tag-utils';

@Component({
  selector: 'app-associated-airports',
  templateUrl: './associated-airports.component.html',
  styleUrls: ['./associated-airports.component.scss']
})
export class AssociatedAirportsComponent implements OnInit {
  @Input() business: Business;
  editModeSet = false;
  isAmbassador = false;
  isRegionalManager = false;

  constructor(private _addAirportsDialog: MatDialog,
              private _toggleService: EditToggleService,
              private _airportService: AirportService,
              private _businessService: BusinessManagerService,
              public snackBar: MatSnackBar) {}

  async ngOnInit() {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
    if (hasTag(this.business.tags, 'Flying Club') && this.business.flyingClub) {
      this.isAmbassador = await this._businessService.isAmbassador();
    }
    this.isRegionalManager = await this._businessService.isRegionalManager()
      && !await this._businessService.userOwnsBusiness(this.business.id);
  }

  openAddAirportsDialog(): void {
    const dialogRef = this._addAirportsDialog.open(EditAddAirportComponent, {
      disableClose: false,
      autoFocus: true,
      data: {
        business: this.business
      }
    });
    dialogRef.afterClosed().subscribe(async () => {
      // Update the business object on close, since it could've been changed
      this.business = await this._airportService.getBusiness(this.business.id.toString());
    });
  }

  async removeAirport(airport: AirportSummary): Promise<void> {
    const dialogRef = this._addAirportsDialog.open(ConfirmRemoveAirportComponent, {
      disableClose: false,
      autoFocus: true,
      data: {
        airportSummary: airport
      }
    });
    dialogRef.afterClosed().subscribe(async confirmed => {
      if (!confirmed) {
        return;
      }
      const responseString = await this._businessService.removeAssociatedAirport(this.business, airport.airportId);
      if (!responseString.includes('deleted')) {
        this.snackBar.open(`Failed to Remove ${airport.faaId} from ${this.business.name}`, 'Close', {
          duration: 2000
        });
      } else {
        this.business = await this._airportService.getBusiness(this.business.id.toString());
      }
    });

  }
}


